<template>
  <div class="declaracao-azulcargo">
    <div class="header">
      <img class="logo" src="/images/azulcargopb.png">
    </div>

    <div class="data-block">
      <div class="input-group-data">
        <div>
          <p class="local-input" style="text-align: left;">{{ (order.from.city || '&nbsp;') | upper}},</p>
        </div>
        <div>
          <p class="data-input" style="text-align: left;">&nbsp;{{moment(order.generated_at).format('DD') }} de {{ moment(order.generated_at).format('MMMM') }} {{ moment(order.generated_at).format('YYYY') }}</p>
        </div>
      </div>

      <p class="align-left space-dec">DECLARAÇÃO DE REMESSA DE CARGA ENTRE PESSOAS FÍSICAS SEM FINS COMERCIAIS</p>

      <div class="dec-responsabilities">
        <p>
          Declaro, para todos os fins, que a presente remessa contendo os itens abaixo relacionados, não
          constitui mercadoria com objetivo comercial e não está sujeita a impostos, especialmente o Imposto
          sobre Circulação de Mercadorias e Serviços (ICMS).
        </p>

        <p>
          Declaro que estou dispensado da emissão de nota fiscal por força da legislação tributária vigente,
          responsabilizando-me, em todas as circunstâncias legais, sobre qualquer informação inverídica declarada.
          Ainda, declaro que nesta embalagem não há qualquer conteúdo ilícito, nocivo, tóxico, perigoso, nem a
          presença de animais vivos ou mortos, objetos com regulamentação específica de posse ou porte ou com
          comercialização ou uso proibido no Brasil.
        </p>

        <p>
          <strong>
            Declaro estar plenamente ciente de que estou sujeito às penalidades legais civis e criminais em
            caso de declaração inverídica, incompleta e/ou incorreta relacionada ao conteúdo por mim informado
            neste documento.
          </strong>
        </p>
      </div>

      <table class="product-table">
        <tr>
          <th>Qtde.</th>
          <th class="column-product" style="width: 45%;">Descrição</th>
          <th>Valor Unit. (R$/un.)</th>
          <th>Valor Total (R$)</th>
        </tr>

        <tr class="declaration-items" v-for="product in order.products" :key="product.id">
          <td style="padding: 0 5px; text-align: center;">{{ product.quantity }}</td>
          <td style="padding: 0 5px; text-align: center;">{{ product.name }}</td>
          <td style="padding: 0 5px; text-align: center;">{{ (product.unitary_value) | currency }}</td>
          <td style="padding: 0 5px; text-align: center;">{{ (product.unitary_value * product.quantity) | currency }}</td>
        </tr>

        <template v-if="order.products.length < 4">
          <tr class="border" v-for="n in (4 - order.products.length)" :key="n">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </template>

        <tr class="border" style="text-align: center">
          <td colspan="3">TOTAL</td>
          <td>{{ totals.price | currency }}</td>
        </tr>
      </table>

      <p class="align-center space-botton">(ATENÇÃO: valor máximo aceito por remessa sem nota fiscal: R$ 1.000,00)</p>

      <p class="">Nome completo:</p>
      <div class="input-field">
        <p class="input-name" style="text-align: left;">{{ order.from.name }}</p>
      </div>

      <p class="">Endereço completo:</p>
      <div class="input-field">
        <p class="input-name" style="text-align: left;">{{ order.from.address | upper }} {{ order.from.location_number | upper }} {{ (order.from.complement || '&nbsp;') | upper }}</p>,
      </div>

      <div class="label-group-contact">
        <p class="align-left">DDD</p>
        <p class="align-left">Telefone</p>
        <p class="align-left">E-mail</p>
      </div>

      <div class="input-group-contact">
        <div class="input-field">(
          <p class="small-input" style="text-align: center;">
            <template v-if="order.from.phone">0{{ String(order.from.phone).substr(0, 2) }}</template>
            <template v-else>&nbsp;</template>
          </p>)
        </div>
        <div class="input-field">
          <p class="medium-input" style="text-align: left;">
            <template v-if="order.from.phone">{{ String(order.from.phone).substr(2) }}</template>
            <template v-else>&nbsp;</template>
          </p>
        </div>
        <div class="input-field">
          <p class="extra-large-input" style="text-align: left;">{{ '&nbsp;' }}</p>
        </div>
      </div>

      <div class="label-group-document">
        <p class="align-left">RG</p>
        <p class="align-left">CPF/CNPJ</p>
      </div>

      <div class="input-group-document space-botton">
        <div class="input-field">
            <p class="input-name" style="text-align: left;">{{ '&nbsp;' }}</p>
        </div>
        <div class="input-field">
            <p class="input-name" style="text-align: left;">{{ order.from.company_document || order.from.document || '&nbsp;'  }}</p>
        </div>
      </div>

      <p class="align-center">Destinatário</p>

      <p class="">Nome completo:</p>
      <div class="input-field">
        <p class="input-name" style="text-align: left;">{{ order.to.name }}</p>
      </div>

      <p class="">Endereço completo:</p>
      <div class="input-field">
        <p class="input-name" style="text-align: left;">{{ order.to.address | upper }} {{ order.to.location_number | upper }} {{ (order.to.complement || '&nbsp;') | upper }}</p>,
      </div>

      <div class="label-group-contact">
        <p class="align-left">DDD</p>
        <p class="align-left">Telefone</p>
        <p class="align-left">E-mail</p>
      </div>

      <div class="input-group-contact">
        <div class="input-field">(
          <p class="small-input" style="text-align: center;">
            <template v-if="order.from.phone">0{{ String(order.to.phone).substr(0, 2) }}</template>
            <template v-else>&nbsp;</template>
          </p>)
        </div>
        <div class="input-field">
          <p class="medium-input" style="text-align: left;">
            <template v-if="order.from.phone">{{ String(order.to.phone).substr(2) }}</template>
            <template v-else>&nbsp;</template>
          </p>
        </div>
        <div class="input-field">
          <p class="extra-large-input" style="text-align: left;">{{ '&nbsp;' }}</p>
        </div>
      </div>

      <div class="label-group-document">
        <p class="align-left">RG</p>
        <p class="align-left">CPF/CNPJ</p>
      </div>

      <div class="input-group-document space-botton">
        <div class="input-field">
            <p class="input-name" style="text-align: left;">{{ '&nbsp;' }}</p>
        </div>
        <div class="input-field">
            <p class="input-name" style="text-align: left;">{{ order.to.company_document || order.to.document || '&nbsp;'  }}</p>
        </div>
      </div>

      <span>
        Assumo total responsabilidade pelas declarações prestadas acima, perante as repartições federais, estaduais e municipais.
      </span>

      <div class="input-sign">
        <div class="input-field">
          <p class="input-name"></p>
        </div>
        <p class="align-center">(Nome, assinatura e RG)</p>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    props: {
      order: {
        type: Object,
        required: true
      }
    },

    methods: {
      moment
    },

    computed: {
      totals: function () {
        let price = 0;
        let quantity = 0;
        this.order.products.forEach((e) => {
          price += e.quantity * e.unitary_value;
          quantity += e.quantity;
        });

        return {
          'price': price,
          'quantity': quantity
        };
      }
    },

    filters: {
      currency(value, currency = 'R$', hasZero = true) {
        value = String(value);
        let matches = value.match(/(\,|\.)(\d{2})$/);
        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        value = parseFloat(value);
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        if (!hasZero && !value) return '-';
        return currency + ' ' + Number(value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
      upper(text) {
        return String(text || '').toUpperCase();
      }
    },

    created() {
      moment.locale('pt_br');
    },
  }
</script>

<style lang="stylus" scoped>
  .declaracao-azulcargo
    padding 8px 30px
    font-family "Times New Roman", Times, serif
    line-height 24px

    p
      margin 0
      line-height 20px

  .header
    display grid
    grid-template-columns 2fr 8fr

  .logo
    width 200px

  .title
    font-family Arial, Helvetica, sans-serif
    font-weight normal
    font-size 48px
    margin 0
    justify-self center
    align-self center

  .data-block
    margin-top 20px

  .input-group-address,
  .label-group-address
    display grid
    grid-template-columns 4fr 6fr

  .input-group-state,
  .label-group-state
    display grid
    grid-template-columns 2fr 3fr 1fr

  .input-group-contact,
  .label-group-contact
    display grid
    grid-template-columns 1fr 2fr 3fr 3fr

  .input-group-document,
  .label-group-document
    display grid
    grid-template-columns 3fr 3fr

  .input-group-data,
  .label-group-data
    width 90%
    display grid
    grid-template-columns 1fr 4fr

  .input-group-state
    & > .input-field
      & > .small-input
        width 92%
      & > .medium-input
        width 96%
      & > .big-input
        width 97%

  .input-group-address
    & > .input-field
      & > p
        width 97%
      & > .small-input
        width 92%

  .input-group-contact
    & > .input-field
      & > .small-input
        width 70%
      & > .medium-input
        width 98%
      & > .big-input
        width 96%
      & > .extra-large-input
        width 184%

  .input-group-data
    & > .input-field
      & > .local-input
        width 96%
      & > .data-input
        width 91%

  .label-group-contact
    margin-bottom 0px

  .label-group-data
    margin-bottom 35px

  .input-field-recipient
    display inline
    & > p
      width 86%

  .input-field
    & > p
      border-bottom 1px solid #000
      display inline-block

  .input-name
    width 98%

  .input-address
    width 88.5%

  .dec-responsabilities
    p:not(:last-of-type)
      margin-bottom 10px

  .space-dec
    padding 5px 0px

  .space-botton
	  padding-bottom 7px

  .align-right
    text-align right
  .align-center
    text-align center
  .product-table
    border-collapse collapse
    width 100%
    margin 15px 0
    th, td
      border 1px solid #000
    td
      padding 10px
    .declaration-items
      word-break break-word
</style>
